import { useTranslation } from 'react-i18next';
import de from './locales/de';
import en from './locales/en';
import tr from './locales/tr';

const LOCALES = { de, en, tr };

export default function useLocale() {
  const { i18n, t } = useTranslation();
  const lang = i18n.language && LOCALES[i18n.language] ? i18n.language : 'de';
  return { L: LOCALES[lang], lang, t, i18n };
}
